<template>
  <el-form
    ref="form"
    :rules="rules"
    :model="model"
    label-width="80px"
    label-position="right"
  >
    <el-form-item
      label="Nombre"
      prop="name"
    >
      <el-input
        v-model="model.name"
      />
    </el-form-item>
    <el-form-item
      label="Periodo"
      prop="$dateRange"
    >
      <el-date-picker
        v-model="model.$dateRange"
        type="daterange"
        range-separator="-"
        start-placeholder="Inicio"
        end-placeholder="Fin"
        @change="updateDates"
      />
    </el-form-item>
  </el-form>
</template>

<script>
import Period from './period.model'
import { mapActions } from 'vuex'

export default {
  name: 'PeriodsForm',
  components: {},
  props: {
    old: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      model: Period.model(),
      rules: Period.rules
    }
  },
  validations: Period.validations,
  mounted () {
    this.model = Object.assign(this.model, this.old)
    this.model.$dateRange = []
    this.model.$dateRange[0] = this.old.startDate
    this.model.$dateRange[1] = this.old.endDate
  },
  methods: {
    ...mapActions('periods', ['save', 'query']),
    onSubmit () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.save(this.model)
            .then(response => {
              this.query().then(() => {
                this.$router.push({ name: 'periods' })
              })
            })
            .catch(error => {
              return Promise.reject(error)
            })
        } else {
          this.$notify({
            group: 'app',
            title: 'Verifica la forma.',
            text:
              'Por favor, revisa lo errores que se indican dentro de la forma.'
          })
          return false
        }
      })
    },
    updateDates () {
      this.model.startDate = this.model.$dateRange[0]
      this.model.endDate = this.model.$dateRange[1]
    }
  }
}
</script>

<style
  lang="scss"
  scoped
>
</style>



// WEBPACK FOOTER //
// src/modules/periods/periods-form.vue